import { Card, CardContent } from "@bcc/components/ui/card";
import { useTranslation } from "react-i18next";
import { setOrdersStatsTestId, statsConfig } from "./orders-stats.utils";

interface OrdersStatsProps {
  testId?: string;
}

export function OrdersStats({ testId }: OrdersStatsProps = {}) {
  const { t } = useTranslation();

  return (
    <div
      data-testid={testId ?? setOrdersStatsTestId("container")}
      className="grid gap-4 md:grid-cols-2 lg:grid-cols-4"
    >
      {statsConfig.map((stat) => {
        const name = t(stat.nameKey) as string;
        return (
          <Card key={stat.nameKey}>
            <CardContent className="p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-muted-foreground">
                    {name}
                  </p>
                  <p className="mt-2 text-3xl font-bold tracking-tight">
                    {stat.value}
                  </p>
                </div>
                <div
                  className={`flex h-12 w-12 items-center justify-center rounded-xl ${stat.iconBg}`}
                >
                  <stat.icon className={`h-6 w-6 ${stat.iconColor}`} />
                </div>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
